// extracted by mini-css-extract-plugin
export default {"jindutiao_bg":"jindutiao_bg__nARZ2","jindutiao":"jindutiao__yljgU"};